import {
  BookCheck,
  Briefcase,
  BriefcaseBusiness,
  FileText,
  GraduationCap,
  Languages,
  Plane,
  Scale,
  Shield,
  User,
  Wrench,
} from "lucide-react";

export const tabs = [
  { id: "cv", name: "CV", icon: FileText },
  { id: "personal", name: "Bio Data", icon: User },
  // {
  //   id: "aviation_category",
  //   name: "Aviation Category",
  //   icon: Plane,
  // },
  // { id: "licenses", name: "Licenses", icon: BookCheck },
  // { id: "experience", name: "Experience", icon: Briefcase },
  { id: "qualifications", name: "Qualifications", icon: GraduationCap },
  { id: "experience2", name: "Experience", icon: Briefcase },
  // { id: "professional", name: "Professional", icon: Wrench },
  {
    id: "employment_history",
    name: "Employment History",
    icon: BriefcaseBusiness,
  },
  // {
  //   id: "regulatory_body",
  //   name: "Regulatory Body",
  //   icon: Scale,
  // },
  // {
  //   id: "icao_language_proficiency",
  //   name: "Icao Language Proficiency",
  //   icon: Languages,
  // },
  { id: "documents", name: "Supporting Documents", icon: FileText },
  { id: "visibility", name: "Visibility Settings", icon: Shield },
];
